import { finalPageData } from '../../content/finalPageData';
import { analyticsGoals, trackAnalyticsGoal } from '../../lib/analytics/yandexMetrika';
import styles from './ContactSection.module.scss';

export function ContactSection() {
  const { telegram, phone } = finalPageData.contacts;

  return (
    <section className={styles.section} id="contacts" aria-labelledby="contacts-title">
      <div className={styles.inner}>
        <div className={styles.copy} data-reveal>
          <p className={styles.eyebrow}>Связаться с нами</p>
          <h2 id="contacts-title">Подберём участок и рассчитаем полный бюджет</h2>
          <div className={styles.lead}>
            <p>
              Расскажем о свободных участках, сравним расположение и поможем выбрать подходящий
              вариант с учётом ваших планов по строительству.
            </p>
            <p>
              Рассчитаем стоимость земли и объясним условия бронирования, рассрочки и ипотеки. Если
              вас интересует квартал "Горизонт" в едином архитектурном стиле, сообщим о готовности проектов и начале продаж.
            </p>
          </div>
        </div>

        <div className={styles.actions} data-reveal data-reveal-delay="1">
          <a
            className={styles.primaryAction}
            href="#genplan"
            onClick={() => trackAnalyticsGoal(analyticsGoals.lotSelectClick)}
          >
            <span>Выбрать участок на генплане</span>
            <span aria-hidden="true">→</span>
          </a>

          {telegram ? (
            <a
              className={styles.secondaryAction}
              href={telegram.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackAnalyticsGoal(analyticsGoals.telegramClick)}
            >
              Записаться на просмотр <span aria-hidden="true">↗</span>
            </a>
          ) : null}

          {phone ? (
            <a className={styles.phone} href={phone.href}>
              {phone.label}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
